export default __webpack_public_path__ + "static/media/mail.c6f3f77c.svg";